/* eslint-disable code-style/no-hardcoded-strings */

import { Box, styled } from "@mui/material";

const sidebarWidth = 240;

export const StyledContent = styled(
    Box,
    { shouldForwardProp: (prop) => prop !== "open" },
)(({
    open,
    theme,
}) => ({
    flexGrow: 1,
    marginTop: 65,
    transition: theme.transitions.create(
        ["width", "margin"],
        {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp,
        },
    ),
    width: "85%",
    ...open && {
        transition: theme.transitions.create(
            "width",
            {
                duration: theme.transitions.duration.enteringScreen,
                easing: theme.transitions.easing.sharp,
            },
        ),
        width: `calc(100% - ${sidebarWidth}px)`,
    },
}));
